var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widthFull mainBackground h-100 somatoline" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container dataContainer" }, [
        _c(
          "form",
          {
            staticClass: "pb-5",
            attrs: { id: "ibanInsert" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.ibanInsert.apply(null, arguments)
              }
            }
          },
          [
            _c("div", { staticClass: "row justify-content-center mt-5 pb-5" }, [
              _c("div", { staticClass: "col-md-6 mt-5 pt-5" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("small", { staticClass: "back-white center" }, [
                  _vm._v(
                    "I dati inseriti serviranno per poter ricevere gli eventuali rimborsi a cui si ha accesso tramite le promozioni in piattaforma."
                  )
                ]),
                _c("br"),
                _vm._v(" "),
                _c("small", { staticClass: "back-white center" }, [
                  _vm._v(
                    "Successivamente non sará possibile modificare i dati che si\n            stanno inserendo in questo form."
                  )
                ]),
                _vm._v(" "),
                _c("small", { staticClass: "back-white center" }, [
                  _vm._v("Operazione richiesta solo al primo login.")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "group mt-5" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.accHolder,
                        expression: "accHolder"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: { required: true, min: 5 },
                        expression: "{ required: true, min: 5 }"
                      }
                    ],
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.errors.has("accHolder"),
                      valid: !!_vm.accHolder
                    },
                    attrs: {
                      type: "text",
                      id: "accHolder",
                      name: "accHolder",
                      "data-vv-as": "Intestatario"
                    },
                    domProps: { value: _vm.accHolder },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.accHolder = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "highlight" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "bar" }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "niceInputLabel",
                      attrs: { for: "accHolder" }
                    },
                    [_vm._v("Intestatario Iban")]
                  ),
                  _vm._v(" "),
                  _vm.errors.has("accHolder")
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.errors.first("accHolder")) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.iban,
                        expression: "iban"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: {
                          required: true,
                          ibanItalian: true,
                          ibanControl: true,
                          min: 5
                        },
                        expression:
                          "{\n                required: true,\n                ibanItalian: true,\n                ibanControl: true,\n                min: 5,\n              }"
                      }
                    ],
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.errors.has("iban"),
                      valid: !!_vm.iban
                    },
                    attrs: {
                      type: "text",
                      id: "iban",
                      name: "iban",
                      "data-vv-as": "Iban"
                    },
                    domProps: { value: _vm.iban },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.iban = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "highlight" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "bar" }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "niceInputLabel", attrs: { for: "iban" } },
                    [_vm._v("Iban")]
                  ),
                  _vm._v(" "),
                  _vm.errors.has("iban")
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.errors.first("iban")) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm._m(1)
              ])
            ])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "uppercase darkBlue  mt-5" }, [
      _c("b", [_vm._v("Prima di poter procedere é necessario inserire l'iban")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "center mt-5 mt-md-3 mb-md-0 mb-5 pb-5" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary btn-lg mr-md-5",
          attrs: { tag: "button" }
        },
        [_vm._v("\n              CONFERMA\n            ")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70f32a19", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70f32a19","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/iban/index.vue
// module id = null
// module chunks = 